import { ActionType, ProColumns } from '@ant-design/pro-components'
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable'
import { cloneDeep } from 'lodash'
import { observer } from 'mobx-react'
import { SearchModel } from 'pages/model'
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { WarrantyActiveReportModel } from 'services/Main/reportVisitCustomerSR'
import { reportVisitCustomerSRPresenter, reportVisitCustomerSRStore } from 'stores/root_store'

type Props = {
  dataSearch: SearchModel
  handleSearch: Dispatch<SetStateAction<SearchModel>>
}

const TableLastConsumer = ({ dataSearch, handleSearch }: Props) => {
  const { t } = useTranslation();
  const tableRef = useRef<ActionType>();

  const [dataTable, setDataTable] = useState<WarrantyActiveReportModel[]>([]);

  const [totalCount, setTotalCount] = useState<number | undefined>()

  // lấy data báo cáo =============================================================================
  const getDataReport = async (dataSearch: object) => {
    await reportVisitCustomerSRPresenter.getDataReportWarrantyActive(reportVisitCustomerSRStore, dataSearch);
    if (reportVisitCustomerSRStore.reportWarrantyActive.isSuccess) {
      const dataTemp = cloneDeep(reportVisitCustomerSRStore.reportWarrantyActive.data);
      setDataTable(dataTemp);

      setTotalCount(reportVisitCustomerSRStore.reportWarrantyActive.paging?.totalCount)
      return dataTemp;
    }
    setDataTable([]);
    return [];
  }

  // load lại request mỗi khi bấm nút tìm kiém
  useEffect(() => {
    if (dataSearch.isReload) {
      tableRef.current?.reload()
      handleSearch({ ...dataSearch, isReload: false })
    }
  }, [dataSearch.isReload])

  const [columns, setColumns] = useState<ProColumns<WarrantyActiveReportModel>[]>([
    // stt
    {
      title: t('zalo-notification.stt'),
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 30,
      align: 'center',
    },
    //   SO
    {
      title: "SO",
      dataIndex: 'so',
      key: 'so',
      width: 60,
    },
    //   Mã khách hàng
    {
      title: t('project-report.customer-code'),
      dataIndex: 'profileCode',
      key: 'profileCode',
      width: 80,
    },
    // Tên sản phẩm
    {
      title: t("warranty-active.prd-name"),
      dataIndex: 'productName',
      key: 'productName',
      width: 120,
    },
    //   Serial SP
    {
      title: t("warranty-active.serial-prd"),
      dataIndex: 'serial',
      key: 'serial',
      width: 120,
    },
    // Tên bảo hành
    {
      title: t('project-report.warranty-name'),
      dataIndex: 'warrantyName',
      key: 'warrantyName',
      width: 100,
    },

    // AC kích hoạt
    {
      title: t('project-report.active-ac'),
      dataIndex: 'acActivedDate',
      key: 'acActivedDate',
      width: 60,
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Đại lý kích hoạt
    {
      title: t('project-report.active-retail'),
      dataIndex: 'distributorActivedDate',
      key: 'distributorActivedDate',
      width: 60,
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },

    // Khách hàng kích hoạt
    {
      title: t("warranty-active.active-by-customer"),
      dataIndex: 'customerActivedDate',
      key: 'customerActivedDate',
      width: 60,
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Ngày kết thúc bảo hành
    {
      title: t('project-report.warranty-end-date'),
      dataIndex: 'endDateWarranty',
      key: 'endDateWarranty',
      width: 60,
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
  ])

  return (
    <CustomProTable
      bordered
      columns={columns}
      dataSource={dataTable}
      rowKey={'stt'}
      actionRef={tableRef}
      request={async (params = {}, sort, filter) => {
        let data: WarrantyActiveReportModel[] = [];
        data = await getDataReport(dataSearch);
        return {
          data: data,
          success: reportVisitCustomerSRStore.reportWarrantyActive.isSuccess,
        };
      }}
      pagination={{
        ...tablePagination(dataSearch, handleSearch),
        total: totalCount,
      }}
    />
  )
}

export default observer(TableLastConsumer)